import {localStorageKey} from "@/api/config";
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import _ from "lodash";
import Api from "@/api";
import StoragePlugin from 'vue-web-storage';
import VueDayjs from 'vue3-dayjs-plugin'
import PageHeader from "@/components/PageHeader.vue";
import SideMenu from "@/components/SideMenu.vue";
import 'dayjs/locale/ko';
import {vfmPlugin} from "vue-final-modal";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import ko from "element-plus/dist/locale/ko"
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import $ from 'jquery';

import { configure } from 'vee-validate';
configure({
    validateOnBlur: false, // controls if `blur` events should trigger validation with `handleChange` handler
    validateOnChange: true, // controls if `change` events should trigger validation with `handlemitter eChange` handler
    validateOnInput: true, // controls if `input` events should trigger validation with `handleChange` handler
    validateOnModelUpdate: true, // controls if `update:modelValue` events should trigger validation with `handleChange` handler
});
window.$ = $
window.global = window;
let app = createApp(App);
app.use(router)
app.use(vfmPlugin)
app.use(StoragePlugin, {
    prefix: localStorageKey,
    drivers: ['local'],
})
app.use(VueDayjs)
app.component('page-header', PageHeader)
app.component('side-menu', SideMenu)
//createApp(App).use(store).use(router).mount('#app')

app.config.globalProperties.$api = Api;
app.config.globalProperties.$_ = _;

app.use(ElementPlus, {
    locale: ko
})
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(store)
app.mount('#app')
